interface NavbarHamburguerProps {
  isOpen?: boolean;
  onClick?: () => void;
}

export function NavbarHamburguer({ 
  isOpen = false, 
  onClick = () => {} 
}: NavbarHamburguerProps) {
  return (
    <button
      className={`nav__hamburguer ${isOpen ? "nav__hamburguer--aberto" : ""}`}
      onClick={onClick}
      aria-label={isOpen ? "Fechar menu" : "Abrir menu"}
      aria-expanded={isOpen}
    >
      <span />
      <span />
      <span />
    </button>
  );
}